import { render, staticRenderFns } from "./NationalMaterialsView.vue?vue&type=template&id=5333fe60&"
import script from "./NationalMaterialsView.vue?vue&type=script&lang=js&"
export * from "./NationalMaterialsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports